import BehaviorConfig from '@/models/app-config/behavior/behavior'
import {
  AppliedBundleDiscount,
  BundleDiscountWithBrand,
} from '@/services/api/bundle-discount'
import { InstanceResolver } from '@/util/instanceResolver'
import { Context, SingleBundleRecommendationParameter } from '../../../single-parameter'
import { BundleRecommendationParameterCreationPolicy } from '../creation-policy'
import { Cart as CartForFilter, EnabledByBrandSpecification, filterNotYetAppliedBundleDiscount } from '../filter/filter-not-yet-applied'

import { none, Option, some } from 'fp-ts/lib/Option'
import _ from 'lodash'

/**
 * カートアイテム、バンドル割引情報、バンドル設定情報をもとに、バンドルリコメンデーションの対象となる単一のバンドル設定情報を選び出し、
 * そのリコメンデーションUI表示に必要なパラメータを生成する。
 */
export class SingleBundleRecommendationParameterCreationPolicy
  implements BundleRecommendationParameterCreationPolicy<SingleBundleRecommendationParameter> {
  constructor(
    private readonly cartList: Cart[],
    private readonly appliedBundleDiscountList: AppliedBundleDiscount[],
    private readonly bundleDiscountList: BundleDiscountWithBrand[],
    private readonly enabledByBrandSpecification: EnabledByBrandSpecification
     = new DefaultEnabledByBehaviorSpecification()
  ) {}

  create(): Option<SingleBundleRecommendationParameter> {
    const candidateDiscountList = filterNotYetAppliedBundleDiscount(
      this.cartList,
      this.appliedBundleDiscountList,
      this.bundleDiscountList,
      this.enabledByBrandSpecification
    )

    // TODO: 表示すべきバンドルキャンペーン候補が複数ある場合は、優先度などの基準によって一つの候補に絞り込まれる予定。
    const candidate = _.isEmpty(candidateDiscountList) ? null : candidateDiscountList[0]

    if (!candidate) {
      return none
    }

    const context = InstanceResolver.isSingle() ?
      Context.asSingleInstance() : Context.asMultiInstance(
        {
          englishName: candidate.brand.brand_english_name,
        }
      )

    return some(new SingleBundleRecommendationParameter(
      context,
      {
        id: candidate.id,
        title: candidate.title,
        campaignId: candidate.campaign_id,
      }
    ))
  }
}

type Cart = CartForFilter

class DefaultEnabledByBehaviorSpecification implements EnabledByBrandSpecification {
  enabled(brandEnglishName: string): boolean {
    return BehaviorConfig.createFromBrand(brandEnglishName).bundleRecommendation.show
  }
}
